import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { NavLink, useLocation } from "react-router-dom";
import { ReactComponent as AIEmoji } from "assets/svg/ai-emoji.svg";
import { SettingsRoute } from "../settings-routes";

const SettingsSidebar = ({ routes }: { routes: SettingsRoute[] }) => {
  const { pathname } = useLocation();
  const [, setInnerWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  const activeRoute = (routeName) => {
    return pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  return (
    <div className={styles["settings-sidebar"]}>
      <div className={styles["settings-sidebar-wrapper"]}>
        <div className={styles["settings-sidebar__title"]}>Settings</div>
        <ul className="nav">
          {routes
            .filter((route) => route.exact)
            .map((prop, key) => {
              return (
                <li className={activeRoute(prop.path)} key={key}>
                  <NavLink
                    to={prop.path}
                    className={({ isActive }) =>
                      `nav-link d-flex align-items-center${
                        isActive ? " active" : ""
                      }`
                    }
                  >
                    <span className="rg-14">{prop.name}</span>
                    {prop.name === "AI Settings" && (
                      <AIEmoji className={"ml-2"} />
                    )}
                  </NavLink>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default SettingsSidebar;
